import SchoolReportForm from "../forms/SchoolReportForm";
import React, {useEffect, useState} from "react";
import PageTitle from "../../../../shared/ui/PageTitle";
import GenericButton from "../../../../shared/ui/GenericButton";
import BoxContent from "../../../../shared/ui/BoxContent";
import Box from "@mui/material/Box";
import {useLocation, useNavigate} from "react-router-dom";
import {APIPostReports} from "../api/schoolReports";
import {useAuth} from "../../../../hooks/useAuth";
import {SubmitHandler, useForm, UseFormReturn} from "react-hook-form";
import moment from "moment/moment";
import {ApiGetAllTags} from "../../../tests/tags/api/testTags";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import ErrorsList from "../../../../shared/ui/ErrorsList";
import FormLabelBox from "../../../../shared/ui/FormLabelBox";
import FormFieldBox from "../../../../shared/ui/FormFieldBox";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const newStandardsDate = process.env.REACT_APP_STANDARDS_DATE ?? new Date();
export interface IFormInputs {
    interval: string;
    tag: any[];
    subject: string;
    classroom: string;
}

type LocationProps = {
    state: {
        type: string;
        classroom_id: number;
    };
};


const schema = yup.object({
    keywords: yup.string(),
});

export interface ISearchForm {
    onSubmit: (data: any) => void;
    startDate: Date | undefined;
    endDate: Date | undefined;
    onDateRangeChange: (dates: any) => void;
    selectClassroomHandler: (event: React.SyntheticEvent, value: any) => void;
    tags: any[];
    methods:  UseFormReturn<IFormInputs, object>;
    classroomId?: number | undefined;
    classroom: number | undefined;
    type: string;
    isStandard: string;
    handleSelectChange: (e: React.FormEvent<HTMLInputElement>) => void;
    subjects: any[];
}

const DEFAULT_SUBJECTS = [
    {label: "Bac Mate/Științe", value: "21", subject: "Bac Mate/Științe", item_type_id: 21, grades: [901]},
    {label: "Bac Mate-Info", value: "212", subject: "Bac Mate-Info", item_type_id: 21, grades: [902]},
    {label: "Bac Română", value: "213", subject: "Bac Română", item_type_id: 21, grades: [903]},
    {label: "Evaluare nationala romana", value: "20", subject: "Evaluare nationala romana", item_type_id: 20, grades: [47]},
    {label: "Evaluare nationala matematica", value: "201", subject: "Evaluare nationala matematica", item_type_id: 20, grades: [48]},
    // {label: "Literație", value: "19", subject: "Literație", item_type_id: 19, grades: [41, 42, 43, 44, 45, 46]},
    // {label: "Literație digitală", value: "24", subject: "Literație digitală", item_type_id: 24, grades: [70, 71, 72]},
    // {label: "Literație numerică", value: "41", subject: "Literație numerică", item_type_id: 41, grades: [190, 191, 192, 197]},
    // {label: "Literație numerică", value: "41"},
];

const SUBJECTS = [
    { label: "Istorie", value: "22", item_type_id: 22, grades: [50, 51, 52, 53, 54, 55, 56, 57] },
    { label: "Matematică", value: "1", item_type_id: 1, grades: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
    { label: "Română", value: "4", item_type_id: 4, grades: [19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30] },
    { label: "Fizică", value: "30", item_type_id: 30, grades: [123, 124, 125, 126, 127, 128, 194]},
    { label: "Chimie", value: "34", item_type_id: 34, grades: [150, 151, 152, 153, 154, 196]},
    { label: "Biologie", value: "33", item_type_id: 33, grades: [136, 137, 138, 139, 140, 141, 142, 193]},
    { label: "Geografie", value: "37", item_type_id: 37, grades: [162, 163, 164, 165, 166, 167, 168, 169, 195]},
    ...DEFAULT_SUBJECTS,
];

const SUBJECTS_STANDARDS = [
    {label: "Comunicare în limba română (CLR)", value: "CLR", item_type_id: null, discipline_id: 1},
    {label: "Limba și literatura română", value: "4", item_type_id: 4, discipline_id: 2, grades: [27, 28, 29, 30] },
    {label: "Matematică și explorarea mediului", value: "MEM", item_type_id: null, discipline_id: 3},
    {label: "Matematică", value: "1", item_type_id: 1, discipline_id: 4, grades: [9, 10, 11, 12] },
    {label: "Istorie", value: "22", item_type_id: 22, discipline_id: 5, grades: [54, 55, 56, 57] },
    {label: "Geografie", value: "37", item_type_id: 37, discipline_id: 6, grades: [167, 168, 169, 195]},
    {label: "Biologie", value: "33", item_type_id: 33, discipline_id: 7, grades: [140, 141, 142, 193]},
    {label: "Chimie", value: "34", item_type_id: 34, discipline_id: 8, grades: [152, 153, 154, 196]},
    {label: "Fizică", value: "30", item_type_id: 30, discipline_id: 9, grades: [126, 127, 128, 194]},
    ...DEFAULT_SUBJECTS,
]

const SchoolReportGenerate = () => {
    const navigate = useNavigate();
    const { update } = useAuth();
    const [tags, setTags] = useState<any[]>([]);
    const [startDate, setStartDate] = useState<Date>();
    const [endDate, setEndDate] = useState<Date>();
    const [errorMessage, setErrorMessage] = useState("");
    const location = useLocation() as unknown as LocationProps;
    const locationPath = useLocation();
    const [classroom, setClassroom] = useState<any>(location.state?.classroom_id);
    const [isStandard, setIsStandard] = useState<string>("1");
    const [subjects, setSubjects] = useState<any[]>(SUBJECTS);
    let classroomId = location.state?.classroom_id;
    let path = locationPath.pathname;
    let type = path.includes("clasa") ? "classroom" : "school";
    const methods = useForm<IFormInputs>({
        resolver: yupResolver(schema),
    });

    useEffect(() => {
        ApiGetAllTags()
            .then((response) => {
                if (response.data.success) {
                    setTags(response.data.data.values);
                    // setLoading(false);
                } else {
                    update("error", { show: true, code: "A002" });
                }
            })
            .catch(() => {
                update("error", { show: true, code: "A001" });
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onDateRangeChange = (dates: any) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
        methods.clearErrors("interval");
    };

    const selectClassroomHandler = (_event: React.SyntheticEvent, option: { value: string } | null) => {
        const selectedClassroomId = option?.value ?? null;
        setClassroom(selectedClassroomId);
    }

    const handleSelectChange = async (e: React.FormEvent<HTMLInputElement>) => {
        const target = e.target as HTMLInputElement;
        const {name, value} = target;

        setIsStandard(value);
        setSubjects(value === "1" ? SUBJECTS : SUBJECTS_STANDARDS);
        setEndDate(undefined);
        setStartDate(undefined);
        methods.reset({tag: []});
        methods.reset({subject: ""});
    };

    const onSubmit: SubmitHandler<IFormInputs> = (data) => {
        methods.clearErrors();
        setErrorMessage("");
        const selectedSubjectArray = subjects.filter((subject) => subject.value === data.subject);
        let selectedSubject = undefined;
        let itemTypeId = undefined;
        let grades: any[] = [];
        let disciplineId = undefined;
        if( selectedSubjectArray.length !== 0) {
            selectedSubject = selectedSubjectArray[0].label;
            itemTypeId = selectedSubjectArray[0].item_type_id;
            grades = selectedSubjectArray[0].grades ?? [];
            disciplineId = selectedSubjectArray[0].discipline_id;
        }
        const selectedTags = data.tag.map((item : {value: string} ) => item.value);


        if(
            selectedTags.length !== 0 ||
            selectedSubject !== undefined ||
            startDate !== undefined ||
            endDate !== undefined
        ) {
            update("loading", { show: true, modal: true });
            APIPostReports({
                has_standard: isStandard === "0",
                tag: selectedTags,
                subject: selectedSubject,
                discipline_id: disciplineId,
                item_type_id: itemTypeId,
                grades: grades,
                start_date: startDate ? moment(startDate).locale("ro").format("YYYY-MM-DD HH:mm:ss") : "",
                end_date: endDate ? moment(endDate).locale("ro").format("YYYY-MM-DD HH:mm:ss") : "",
                type: type,
                type_id: classroomId? classroomId : classroom,
            })
                .then((response) => {
                    if (response.data.success) {
                        update("error", {
                            show: true,
                            closable: true,
                            title: "Raportul a fost generat cu succes!",
                            message: type === "classroom" ? "Acesta va fi disponibil în secțiunea Rapoarte." : "Acesta va fi disponibil în pagina Rapoarte.",
                            icon: "fat face-smile",
                            button: "ÎNCHIDE",
                            returnFunction: () => {
                                navigate(-1);
                            },
                        });
                    } else {
                        update("error", { show: true, code: "A002" });
                    }
                })
                .catch((err) => {
                    if (err.response.status === 400) {
                        let errors = err.response.data.data;
                        if (errors.end_date) {
                            methods.setError("interval", { type: "server", message: errors.end_date[0] });
                        }
                        if (errors.tag) {
                            methods.setError("tag", { type: "server", message: errors.tag[0] });
                        }
                        if (errors.subject) {
                            methods.setError("subject", { type: "server", message: errors.subject[0] });
                        }
                        if(errors.error) {
                            setErrorMessage(errors.error);
                        }
                    } else {
                        update("error", { show: true, code: "A001" });
                    }
                })
                .finally(() => {update("loading", { show: false });})
        } else {
            setErrorMessage("Nu ați modificat niciun câmp.");
        }
    }

    return <Box component="main">
        <PageTitle
            back={true}
            actions={
                <GenericButton
                    type="close"
                    onClick={() => {
                        navigate(-1);
                    }}
                />
            }>
           Generează raport {type === "school" ? "școlar" : "de clasă"}
        </PageTitle>
        {type === "school" &&
            <Typography variant="h3" mb={1.6}>
                Pentru a genera un raport sunt necesare cel putin 10 teste finalizate pentru campurile selectate.
            </Typography>
        }
        <BoxContent>
            <>
                {type === "school" && (
                    <Typography variant="h2" mb={2}>
                        Rapoartele de școală pot fi generate momentan DOAR pe baza testelor efectuate până în data de {moment(newStandardsDate).locale("ro").format("DD.MM.YYYY")}.
                    </Typography>
                )}
            </>

            <Box width="100%">
                <SchoolReportForm
                    startDate = {startDate}
                    endDate = {endDate}
                    selectClassroomHandler = {selectClassroomHandler}
                    onDateRangeChange = {onDateRangeChange}
                    onSubmit = {onSubmit}
                    tags = {tags}
                    methods = {methods}
                    classroomId = {classroomId}
                    classroom = {classroom}
                    type = {type}
                    isStandard = {isStandard}
                    handleSelectChange = {handleSelectChange}
                    subjects = {subjects}
                />
                <Grid container spacing={1.5} alignItems="center">
                    <FormLabelBox />
                    <FormFieldBox>
                        <ErrorsList show={errorMessage !== ""}>{errorMessage}</ErrorsList>
                    </FormFieldBox>
                </Grid>
            </Box>
        </BoxContent>

    </Box>
};

export default SchoolReportGenerate;